function e(e){return null!=e&&void 0!==e.serialize&&"function"==typeof e.serialize}export{e as isSerializable};
